import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import { _setText } from '../../../controllers/dom';
import Map from '../maps/Map';
import ButtonReturnMod from '../configuration/ButtonReturnMod';
import Alert from '../sga/Alert';
import ManageAlert from './ManageAlert';
import { getMarker } from '../../../controllers/markers';

const Sgo = (props) => {
    const { data, ModuleRP, locale, theme } = props;

    const [openAlert, setOpenAlert] = useState(false);
    const [missions, setMissions] = useState([]);
    const [clickData, setClickData] = useState(null);
    const [marker, setMarker] = useState(null);

    useEffect(() => {
        _setText('screenName', `<h4 class="m-1">${locales[locale].sgo.sgo}</h4>`);
        const sortedMissions = [...data.missions].sort((a, b) => b.timestamp - a.timestamp);
        setMissions(sortedMissions);
        if (openAlert) {
            const updatedAlert = sortedMissions.find((mission) => mission.number === openAlert.number);
            setOpenAlert(updatedAlert);
        } else if (ModuleRP.activeMission) {
            const activeMission = sortedMissions.find((mission) => mission.id === ModuleRP.activeMission);
            setOpenAlert(activeMission);
        }
        if (sortedMissions.find((m) => m.notifications.length > 0)) {
            ModuleRP.playAlarm();
        }
    }, [data.missions, locale, ModuleRP.activeMission]);

    useEffect(() => {
        // if (clickData) {
        //
        // }
    }, [clickData]);

    useEffect(() => {
        if (missions.length > 0) {
            const initMarker = async () => {
                for (let i = 0; i < missions.length; i++) {
                    const mission = missions[i];
                    const _marker = {
                        lngLat: mission.location.lngLat,
                        title: `${locales[locale].sga[mission.qualification.category]} - ${mission.qualification.qualification}`,
                        content: `${mission.qualification.informations}\n
                    ${mission.location.numero} ${mission.location.address} ${mission.location.city}`,
                        icon: `/images/markers/${mission.qualification.category}.png`,
                        id: mission.id,
                        callback: () => setOpenAlert(mission),
                    };
                    setMarker(_marker);
                    await new Promise((resolve) => {
                        const checkMarker = setInterval(() => {
                            if (getMarker(mission.id)) {
                                clearInterval(checkMarker);
                                setMarker(null);
                                resolve();
                            }
                        }, 100);
                    });
                }
            };
            initMarker();
        }
    }, [missions]);

    return (
        <div className={`container-fluid bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
            <div className='row'>
                <div className={`col-2 btn-${theme === 'DARK' ? 'dark' : 'light'} btn-sm`}>
                    <ButtonReturnMod loadGame={ModuleRP.loadGame} locale={locale} theme={theme} />
                </div>
            </div>
            <div className='row'>
                {
                    !openAlert ? (
                        <div className='col-6'>
                            <div className='row'>
                                <div className='col-12'>
                                    {
                                        missions.length > 0 ? (
                                            missions.map((mission, index) => (
                                                <Alert key={index} alert={mission} theme={theme} locale={locale} setNewAlert={setOpenAlert} />
                                            ))
                                        ) : (
                                            <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                                <h6 className='alert-heading'>{locales[locale].sga.noAlert}</h6>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='col-8'>
                            <ManageAlert
                                mission={openAlert}
                                locale={locale}
                                theme={theme}
                                setOpenAlert={setOpenAlert}
                                ModuleRP={ModuleRP}
                                buildings={data.buildings}
                                vehicleModels={data.vehicleModels}
                                players={data.players}
                            />
                        </div>
                    )
                }
                <div className={`col-${!openAlert ? '6' : '4'}`}>
                    {
                        data.options.sig.active ? (
                            <Map
                                map={data.options.sig.active ? data.options.sig.type : null}
                                data={data.options.sigData}
                                setClickData={setClickData}
                                cityFocused={''}
                                marker={marker}
                                setMarker={setMarker}
                                gtaMapType={data.options.sigData.gtamap}
                            />
                        ) : (
                            <div className='m-5'>
                                <button className='btn btn-danger' disabled={true}>
                                    {locales[locale].sig.sig}
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default Sgo;
